import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { DataTableComponent } from '../../datatable/datatable.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Datatable } from '../../../models/datatable.model';
import { SharedService } from '../../../services/shared';
import { Router } from '@angular/router';
import { ApiUserDetailsService } from '../../../services/api.user.details.service';
import { ApiUserDetailsEditFormComponent } from './api-user-details-edit-form/api-user-details-edit-form.component';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-api-user-details',
  templateUrl: './api-user-details.component.html',
  styleUrls: ['./api-user-details.component.scss']
})
export class ApiUserDetailsComponent implements OnInit {

  public data;
  public length;
  translations: any;
  pageIndex: Number = 0;
  pageSize: Number = 10;
  filterText: String = '';
  sortDirection: String = 'asc';
  sortHeaderName: String = 'ApiUserName';
  sortColumnNameById: String = 'Id';
  public userApiKey = "";
  

  editFormDialogRef: MatDialogRef<ApiUserDetailsEditFormComponent>;

  constructor(
    private apiUserDetailsService: ApiUserDetailsService,
    public appService: AppService,
    public dialog: MatDialog,
    private datatableProp: Datatable,
    private sharedService: SharedService,
    private configService: ComponentService,
    private router: Router
  ) { 
    
    this.appService.showLoading();
    this.appService.checkSession();
    this.getApiUserDetails();
  }

  ngOnInit() {
    this.setPageTranslations();
  }

  setPageTranslations(){
    this.configService.get('apiuserdetails').subscribe((res) => {
      this.translations = JSON.parse(res['Data']);
      this.appService.hideLoading();
    });
  }

  getApiUserDetails(): void {
    this.appService.showLoading();
    this.apiUserDetailsService.all(this.pageIndex,this.pageSize,this.sortColumnNameById,this.sortDirection,this.filterText).subscribe(
      res => this.getApiUserDetailsSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  apiFaillure(error): void {
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
  }

  getApiUserDetailsSuccess(res): void {
      this.data = [];
      if (res.Status == 1) {
        this.data = JSON.parse(res.Data).Table;
        this.datatableProp = this.appService.mapDataTableProp(this.datatableProp,JSON.parse(res.Data).Table1[0]);      
        this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
        this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
        this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
        this.sharedService.Data.next(this.data);
        this.appService.hideLoading();
      } else if (res.Status == -1) {
        this.apiFaillure(res.Message);
      }
  }

  addRecord(): void {
    this.editFormDialogRef = this.dialog.open(ApiUserDetailsEditFormComponent, {
      disableClose: true,
      data: {
        Id: 0,
        Parent: this
      },
      panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed().subscribe((response) => {
        this.appService.showLoading();    
        this.data = '';
        this.datatableProp = new Datatable();
        this.getApiUserDetails();
    });
  }

  editRecord(e): void {
    this.editFormDialogRef = this.dialog.open(ApiUserDetailsEditFormComponent, {
      disableClose: true,
      data: {
        Id: e.currentTarget.id,
        Parent: this
      },
      panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed().subscribe((response) => {   
      this.appService.showLoading();    
      this.data = '';
      this.datatableProp = new Datatable();
      this.getApiUserDetails();
    });
  }

  deleteRecord(e): void {
    var apiUserDetailsId = e.currentTarget.id;
    this.appService.showDialogue(this.translations.hdConfirm, this.translations.deleteConfirmDialogMessage, true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.delete(apiUserDetailsId);
      }          
    });
  }

  delete(apiUserDetailsId){
    this.apiUserDetailsService.delete(apiUserDetailsId).subscribe(
     res => this.deleteSuccess(res),
     error => this.apiFaillure(error)
    );
 }
 
 deleteSuccess(res){
  if (res.Status == 1){
       this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
       .afterClosed().subscribe(result => {
           if (result) {                     
           this.appService.hideLoading();
           this.data = '';
           this.datatableProp = new Datatable();
           this.getApiUserDetails();
           }          
       });        
   }
   else if (res.Status == -1) {
       this.apiFaillure(res.Message);
   }    
 }
  
  changeAccess(e){
    var apiUserDetailsId = e.currentTarget.id;
    debugger
    this.appService.showDialogue(this.translations.hdConfirm, this.translations.msgGenerateApiKeyConfirm, true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.generateApiKey(apiUserDetailsId);
      }          
    });
  }

  generateApiKey(apiUserDetailsId){
    this.userApiKey = this.getGUID()
    this.apiUserDetailsService.generateApiKey(apiUserDetailsId, this.userApiKey, {}).subscribe(
      res => this.generateApiKeySuccess(res),
      error => this.apiFaillure(error)
    );
  }

  generateApiKeySuccess(res){
    if (res.Status == 1){
         this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
         .afterClosed().subscribe(result => {
             if (result) {                     
             this.appService.hideLoading();
             this.data = '';
             this.datatableProp = new Datatable();
             this.getApiUserDetails();
             }          
         });        
     }
     else if (res.Status == -1) {
         this.apiFaillure(res.Message);
     }    
   }

  public getGUID() {
    let d = new Date().getTime();
    const guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return guid;
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/api-user-details/api-user-details.component.ts